import styled from 'styled-components';

const Copyright = styled.div`
  color: #fff;
  font-size: 0.875rem;
  padding-bottom: 0.5rem;
  @media screen and (min-width: 54.0625em) {
    padding-bottom: 0;
  }
`;

export default Copyright;
